interface Props {
  activeColor: string;
}

const DecisionMakingIcon = ({ activeColor }: Props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="decisionGradient"
          x1="24"
          y1="20"
          x2="104"
          y2="108"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B5CF6" />
          <stop offset="0.5" stopColor="#06B6D4" />
          <stop offset="1" stopColor="#22C55E" />
        </linearGradient>

        <linearGradient
          id="checkGradient"
          x1="46"
          y1="70"
          x2="88"
          y2="90"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#22D3EE" />
          <stop offset="1" stopColor="#4ADE80" />
        </linearGradient>

        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3.5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <rect x="12" y="12" width="104" height="104" rx="28" fill="#0B1220" />
      <rect
        x="12"
        y="12"
        width="104"
        height="104"
        rx="28"
        stroke="url(#decisionGradient)"
        strokeWidth="2"
        opacity="0.5"
      />

      <circle
        cx="64"
        cy="64"
        r="38"
        stroke="url(#decisionGradient)"
        strokeWidth="2"
        opacity="0.18"
      />

      <path
        d="M49 44C49 36.8 54.8 31 62 31C66.3 31 70.1 33 72.5 36.1C73.8 35.4 75.3 35 77 35C82 35 86 39 86 44C86 45.5 85.6 46.9 84.9 48.1C88.5 50.3 91 54.3 91 59C91 64.2 87.9 68.6 83.4 70.5C83.8 71.6 84 72.8 84 74C84 79.5 79.5 84 74 84H57C49.8 84 44 78.2 44 71C44 68.4 44.8 66.1 46.2 64.2C42.4 61.9 40 57.8 40 53C40 47.3 43.5 42.4 49 44Z"
        stroke="url(#decisionGradient)"
        strokeWidth="4"
        strokeLinejoin="round"
        filter="url(#glow)"
      />

      <circle cx="55" cy="49" r="3.5" fill="#A78BFA" />
      <circle cx="73" cy="46" r="3.5" fill="#22D3EE" />
      <circle cx="80" cy="61" r="3.5" fill="#4ADE80" />
      <circle cx="58" cy="67" r="3.5" fill="#67E8F9" />

      <path
        d="M58.5 50H69"
        stroke="#A78BFA"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M73 49.5V57"
        stroke="#22D3EE"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M61 65L76.5 62"
        stroke="#4ADE80"
        strokeWidth="2.5"
        strokeLinecap="round"
      />

      <path
        d="M50 82L59 91L80 72"
        stroke="url(#checkGradient)"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        filter="url(#glow)"
      />
    </svg>
  );
};

export default DecisionMakingIcon;
